import react from "react";
import {
  FButton,
  FDialog,
  FGrid,
  FGridItem,
  FTypo,
} from "ferrum-design-system";
import WindowLockWarningIcon from "../../../../assets/img/warning-icon.svg";

export const MsAddTokenDialog = ({ show, onHide }: any) => {
  return (
    <>
      <FDialog
        show={show}
        onHide={onHide}
        size={"medium"}
        variant={"trade-dialog"}
      >
        <div className="f-ml-1 f-mb-4">
          <div className="justify_start d-flex">
            <img src={WindowLockWarningIcon} />
            <FTypo
              color="#d9b373"
              size={20}
              alignX={"start"}
              display={"flex"}
              className="f-ml-1"
            >
              Trade at your own risk.
            </FTypo>
          </div>
          <FTypo size={13} className={"f-mt-1 text-align-start"}>
            Anyone can create a token, including <br /> creating fake versions
            of existing tokens <br /> that claim to represent projects.
            <br />
            <FTypo size={13} className={"f-mt-1"}>
              If you purchase this token, you may not be <br /> able to sell it
              back.
            </FTypo>
          </FTypo>
          <FGrid>
            <FGridItem size={[6, 6]} className={"f-mt-1 justify-start"}>
              <div className="w-100">
                <FButton
                  title={" Cancel "}
                  className="clr_black_new  w-100"
                  onClick={() => onHide()}
                />
              </div>
            </FGridItem>
            <FGridItem size={[6, 6]} className={"f-mt-1 justify-start"}>
              <div className="w-100">
                <FButton
                  title={" OK, Import "}
                  className=" clr_black_new w-100"
                  onClick={() => onHide()}
                />
              </div>
            </FGridItem>
          </FGrid>
        </div>
      </FDialog>
    </>
  );
};
